/**
 * RefAreaPreviewContext — isolated ephemeral state for the wing_area slider
 * preview. Separated from ProvenanceContext so slider drags only re-render
 * the two consumers that need it (RefQuantityEditModal + usePlotComparison),
 * not the entire DAG/layout tree.
 */

import { createContext, useContext, useState, type ReactNode } from "react";

interface RefAreaPreviewValue {
  previewRefArea: number | null;
  setPreviewRefArea: (value: number | null) => void;
}

const RefAreaPreviewContext = createContext<RefAreaPreviewValue>({
  previewRefArea: null,
  setPreviewRefArea: () => {},
});

export function useRefAreaPreview(): RefAreaPreviewValue {
  return useContext(RefAreaPreviewContext);
}

export function RefAreaPreviewProvider({ children }: { children: ReactNode }) {
  const [previewRefArea, setPreviewRefArea] = useState<number | null>(null);
  return (
    <RefAreaPreviewContext.Provider value={{ previewRefArea, setPreviewRefArea }}>
      {children}
    </RefAreaPreviewContext.Provider>
  );
}
